// Per-route chrome flags. Conversion/secure surfaces (auth, account, staff
// consoles, checkout success) never mount the Three.js canvas or the chat widget.

export interface RouteChrome {
  three3d: boolean;
  chat: boolean;
  marquee: boolean;
}

const NO_CHAT = new Set([
  '/login',
  '/register',
  '/admin',
  '/support',
  '/chat-directory',
  '/success',
]);

export function routeChrome(pathname: string): RouteChrome {
  return {
    three3d: pathname === '/',
    chat: !NO_CHAT.has(pathname),
    marquee: pathname !== '/services/gold',
  };
}
